import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { CopyFromDepartmentRequest } from 'src/types/department';
import axiosInstance from 'src/utils/axios';

interface UseCopyFromDepartmentMutationOptions {
  companyId: string;
  sourceDepartmentId: number;
  onSuccess?: (data: AxiosResponse<any>) => void;
  onError?: (error: any) => void;
}

const useCopyFromDepartmentMutation = ({
  companyId,
  sourceDepartmentId,
  onSuccess,
  onError,
}: UseCopyFromDepartmentMutationOptions) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (params: CopyFromDepartmentRequest) => {
      const res = await axiosInstance.post(
        api.copyFromDepartment(companyId, sourceDepartmentId),
        params
      );
      return res;
    },
    onSuccess: (data) => {
      // Invalidate department list queries to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.department.departmentList(companyId.toString())],
      });
      // Invalidate clients query to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.company.clients(companyId.toString())],
      });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useCopyFromDepartmentMutation;
